//#region src/paytronix_check_number_source.ts
let PaytronixCheckNumberSource = /* @__PURE__ */ function(PaytronixCheckNumberSource) {
	PaytronixCheckNumberSource["Bite"] = "bite";
	PaytronixCheckNumberSource["Pos"] = "pos";
	return PaytronixCheckNumberSource;
}({});
//#endregion
export { PaytronixCheckNumberSource };

//# sourceMappingURL=paytronix_check_number_source.js.map